module.exports = __webpack_public_path__ + "static/img/head_8.76ea0294.png";